import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Page Components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import EventsPage from './pages/EventsPage';
import GalleryPage from './pages/GalleryPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import LMSPage from './pages/LMSPage';
import ShopPage from './pages/ShopPage';
import RC2021Page from './pages/RC2021Page';
import WorkshopsPage from './pages/WorkshopsPage';
import StudentInnovationPage from './pages/StudentInnovationPage';

// Utility Components
import ImageChecker from './components/utils/ImageChecker';

function App() {
  useEffect(() => {
    // Initialize AOS animation library with modern settings
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-cubic',
      mirror: false,
      offset: 50,
    });

    // Add smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-white">
        <Header />
        <main className="flex-grow pt-[112px]">
          <div className="relative">
            {/* Background gradient decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 opacity-50" />
            
            {/* Main content */}
            <div className="relative">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/courses/:courseId" element={<CourseDetailPage />} />
                <Route path="/workshops" element={<WorkshopsPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/lms" element={<LMSPage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/RC2021" element={<RC2021Page />} />
                <Route path="/student-innovation" element={<StudentInnovationPage />} />
                <Route path="/image-checker" element={<ImageChecker />} />
              </Routes>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
